// extracted by mini-css-extract-plugin
export default {"modal":"ModalChoice_modal__pgGEt","description":"ModalChoice_description__P1IPh","title":"ModalChoice_title__8uhTQ"};